//component wrapper for font-awesome icons
export default (props: {fa: string; className?: string}) => {
    return <span className={`${props.fa} ${props.className ?? ''}`} />
}
